import LandingPage from './components/LandingPage.vue'
import CourseSelection from './components/CourseSelection.vue'

import Admin from './components/Admin.vue'
import Course from './components/course/Course.vue'

import CourseIntroduction from './components/course/CourseIntroduction.vue'
import CourseBounties from './components/course/CourseBounties.vue'
import CourseCertificate from './components/course/CourseCertificate.vue'

import Chapter from './components/course/chapter/Chapter'

import ChapterMaterials from './components/course/chapter/ChapterMaterials.vue'
import ChapterAssignment from './components/course/chapter/ChapterAssignment.vue'
import ChapterReview from './components/course/chapter/ChapterReview.vue'
import ChapterAllReviews from './components/course/chapter/ChapterAllReviews.vue'


export const routes = [
  { path : '/', 
    name: 'LandingPageLink', 
    components: {
        default: LandingPage
    }
  },
    { path : '/CourseSelection', 
      name: 'CourseSelectionLink', 
      component: CourseSelection 
    },
    { path : '/Admin', 
      name: 'AdminLink', 
      component: Admin 
    },
    { path : '/course/:courseId', 
      name: 'CourseLink', 
      component: Course, 
      children: [
      {
        path: 'introduction', 
        name: 'IntroductionLink', 
        component: CourseIntroduction, 
        props: true
      },
       {
        path: 'chapter/:chapterId', 
        name: 'ChapterLink', 
        component: Chapter, 
        props: true, children:[
          {
            path: 'materials', 
            component: ChapterMaterials, 
            props: true, 
            name:"MaterialsLink",
            meta:{ title: "Chapter - Materials" }
          },
          {
            path: 'assignment', 
            component: ChapterAssignment, 
            props: true, 
            name:"AssignmentLink",
            meta:{ title: "Chapter - Assignment" }
          },
          {
            path: 'review', 
            component: ChapterReview, 
            props: true, 
            name:"ReviewLink",
            meta:{ title: "Chapter - Review" }
          },      
          {
            path: 'allReviews', 
            component: ChapterAllReviews, 
            props: true, 
            name:"AllReviewLink",
            meta:{ title: "Chapter - All Reviews" }
          },  
        ]
      },
      {
        path: 'certificate', 
        name: 'CertificateLink', 
        component: CourseCertificate, 
        props: true, 
        meta:{title: "End"}
      },
      {
        path: 'bounties', 
        name: 'BountiesLink', 
        component: CourseBounties, 
        props: true, meta:{title: "Course Bounties"}
      }      
      ]
      
    }
 ]
 



// WEBPACK FOOTER //
// ./src/routes.js